import { render, staticRenderFns } from "./PlatformNoticeBar.vue?vue&type=template&id=43fc0968&scoped=true&"
import script from "./PlatformNoticeBar.vue?vue&type=script&lang=js&"
export * from "./PlatformNoticeBar.vue?vue&type=script&lang=js&"
import style0 from "./PlatformNoticeBar.vue?vue&type=style&index=0&id=43fc0968&prod&lang=scss&scoped=true&"
import style1 from "./PlatformNoticeBar.vue?vue&type=style&index=1&id=43fc0968&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fc0968",
  null
  
)

export default component.exports